// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.documenttype.knowntypes

import org.multipaz.cbor.DataItem
import org.multipaz.documenttype.knowntypes.PaymentTransaction.Pisp
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr

fun Pisp.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "04AQ19sHq1ZLz_ljIplPb9FzK_Hl0oStaroyuDFAelE")
val Pisp_cborSchemaId = ByteString(-45, -128, 16, -41, -37, 7, -85, 86, 75, -49, -7, 99, 34, -103, 79, 111, -47, 115, 43, -15, -27, -46, -124, -83, 106, -70, 50, -72, 49, 64, 122, 81)

fun Pisp.Companion.fromCbor(data: ByteArray): Pisp {
    return Pisp.fromDataItem(Cbor.decode(data))
}

val Pisp.Companion.cborSchemaId: ByteString
    get() = Pisp_cborSchemaId

fun Pisp.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("legalName", Tstr(this.legalName))
    builder.put("brandName", Tstr(this.brandName))
    builder.put("domainName", Tstr(this.domainName))
    return builder.end().build()
}

fun Pisp.Companion.fromDataItem(dataItem: DataItem): Pisp {
    val legalName = dataItem["legalName"].asTstr
    val brandName = dataItem["brandName"].asTstr
    val domainName = dataItem["domainName"].asTstr
    return Pisp(
        legalName = legalName,
        brandName = brandName,
        domainName = domainName,
    )
}
